/**
 * @generated SignedSource<<86f2d4fbe20ba24eff06a417dddbe6f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueFieldVisibility = "ALL" | "ORG_ONLY" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type FieldsSectionFragment$data = {
  readonly id: string;
  readonly issueType: {
    readonly id: string;
    readonly name: string;
    readonly pinnedFields: ReadonlyArray<{
      readonly __typename: "IssueFieldDate";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldMultiSelect";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldNumber";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldSingleSelect";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      readonly __typename: "IssueFieldText";
      readonly dataType: IssueFieldDataType;
      readonly id: string;
      readonly name: string;
      readonly visibility: IssueFieldVisibility;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null | undefined;
  } | null | undefined;
  readonly repository: {
    readonly isOwnerEnterpriseManaged: boolean | null | undefined;
    readonly isPrivate: boolean;
    readonly owner: {
      readonly databaseId: number | null | undefined;
      readonly issueFieldsEnabled?: boolean;
      readonly login: string;
      readonly pinnedIssueFields?: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "IssueFieldDate";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldMultiSelect";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldNumber";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldSingleSelect";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          readonly __typename: "IssueFieldText";
          readonly dataType: IssueFieldDataType;
          readonly id: string;
          readonly name: string;
          readonly visibility: IssueFieldVisibility;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined> | null | undefined;
      } | null | undefined;
    };
  };
  readonly viewerCanSetFields: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FieldsSectionFieldValues">;
  readonly " $fragmentType": "FieldsSectionFragment";
};
export type FieldsSectionFragment$key = {
  readonly " $data"?: FieldsSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldsSectionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "visibility",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "IssueFieldText",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "IssueFieldSingleSelect",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "IssueFieldMultiSelect",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "IssueFieldDate",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v2/*: any*/),
    "type": "IssueFieldNumber",
    "abstractKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldsSectionFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOwnerEnterpriseManaged",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "login",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "databaseId",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "issueFieldsEnabled",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "name",
                      "value": "issue_fields"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "isFeatureEnabled",
                  "storageKey": "isFeatureEnabled(name:\"issue_fields\")"
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 100
                    }
                  ],
                  "concreteType": "IssueFieldsConnection",
                  "kind": "LinkedField",
                  "name": "pinnedIssueFields",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": "pinnedIssueFields(first:100)"
                }
              ],
              "type": "Organization",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSetFields",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FieldsSectionFieldValues"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "pinnedFields",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "fe9d29a66f11fa97fd7574f26f483b24";

export default node;
